import React, { useState, useEffect, useCallback } from 'react';
import './SplashScreenComponent.css';

const SplashScreenComponent = ({ onReady }) => {
    const [progress, setProgress] = useState(0);
    const [status, setStatus] = useState('جاري تشغيل التطبيق...');
    const [isComplete, setIsComplete] = useState(false);
    const [logoLoaded, setLogoLoaded] = useState(false);

    const statusMessages = [
        { progress: 0, text: 'جاري تشغيل التطبيق...' },
        { progress: 15, text: 'جاري الاتصال بالسيرفر...' },
        { progress: 35, text: 'تم الاتصال بالسيرفر ✓' },
        { progress: 50, text: 'جاري تحميل إعدادات النظام...' },
        { progress: 70, text: 'جاري تحضير البيانات...' },
        { progress: 85, text: 'جاري تهيئة الواجهة...' },
        { progress: 95, text: 'اكتمل التحميل!' },
        { progress: 100, text: 'مرحباً بك في EP-EG' }
    ];

    const getStatusForProgress = useCallback((prog) => {
        for (let i = statusMessages.length - 1; i >= 0; i--) {
            if (prog >= statusMessages[i].progress) {
                return statusMessages[i].text;
            }
        }
        return statusMessages[0].text;
    }, []);

    useEffect(() => {
        let progressValue = 0;

        const progressInterval = setInterval(() => {
            progressValue += Math.random() * 8 + 3;

            if (progressValue >= 100) {
                progressValue = 100;
                clearInterval(progressInterval);
                setProgress(100);
                setStatus('مرحباً بك في EP-EG');
                setIsComplete(true);

                setTimeout(() => {
                    onReady();
                }, 800);
            } else {
                setProgress(Math.min(progressValue, 99));
                setStatus(getStatusForProgress(progressValue));
            }
        }, 150);

        // Hide native splash if exists
        try {
            if (window.Capacitor?.Plugins?.SplashScreen) {
                window.Capacitor.Plugins.SplashScreen.hide();
            }
        } catch (e) {
            // Native splash not available
        }

        return () => clearInterval(progressInterval);
    }, [onReady, getStatusForProgress]);

    return (
        <div className="splash-screen">
            {/* Background Image */}
            <div
                className="splash-background"
                style={{ backgroundImage: `url('/splash-bg.jpg')` }}
            />

            {/* Dark Overlay */}
            <div className="splash-overlay" />

            {/* Main Content - Centered */}
            <div className="splash-main">
                {/* Logo Container */}
                <div className="splash-logo-container">
                    <img
                        src="/app-logo.png"
                        alt="EP-EG"
                        className={`splash-logo ${isComplete ? 'logo-complete' : ''} ${logoLoaded ? 'loaded' : ''}`}
                        onLoad={() => setLogoLoaded(true)}
                        onError={(e) => {
                            if (e.target.src.includes('app-logo.png')) {
                                e.target.src = '/splash-logo.png';
                            } else if (e.target.src.includes('splash-logo.png')) {
                                e.target.src = '/favicon.ico';
                            } else {
                                e.target.style.display = 'none';
                            }
                        }}
                    />
                </div>

                {/* App Name */}
                <h1 className="splash-title">EP-EG</h1>
                <p className="splash-subtitle">نظام إدارة المندوبين الطبيين</p>
            </div>

            {/* Loading Section - Below Center */}
            <div className="splash-loading">
                {/* Progress Bar */}
                <div className="progress-container">
                    <div
                        className="progress-bar"
                        style={{ width: `${progress}%` }}
                    />
                </div>

                {/* Progress Percentage */}
                <div className="progress-info">
                    <span className="progress-text">{Math.round(progress)}%</span>
                    <span className="status-text">{status}</span>
                </div>
            </div>

            {/* Footer - Fixed at Bottom */}
            <div className="splash-footer">
                <p className="powered-by">Powered by EP Group</p>
                <p className="version">v1.0.0</p>
            </div>
        </div>
    );
};

export default SplashScreenComponent;
